import {ActivatedRoute} from '@angular/router';
import {take} from 'rxjs/operators';
import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-not-found',
    template: `
        <h2 style="display: flex; font-size: xxx-large; justify-content: center;">
            404 - Page not found
        </h2>
        <p style="display:flex;  font-size: x-large; justify-content: center;"
           *ngIf="path">You may be looking for the&nbsp; <a style="font-size: x-large;" [routerLink]="path">"{{ path }}"
            page</a></p>
    `
})
export class NotFoundComponent implements OnInit {
    path: string;

    constructor(private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.route.data.pipe(take(1))
            .subscribe((data: { path: string }) => {
                this.path = data.path;
            });
    }
}
